// Browser-side receipt image processing: crop region -> downscale -> JPEG q0.7 -> stamp 250 DPI.
export const TARGET_DPI = 250;
export const MAX_EDGE_PX = 2000;

export async function makeProcessedBlob(imgEl, cropPx) {
  const scaleX = imgEl.naturalWidth / imgEl.width;
  const scaleY = imgEl.naturalHeight / imgEl.height;
  const sw = Math.max(1, Math.round((cropPx?.width || imgEl.width) * scaleX));
  const sh = Math.max(1, Math.round((cropPx?.height || imgEl.height) * scaleY));
  const sx = Math.round((cropPx?.x || 0) * scaleX);
  const sy = Math.round((cropPx?.y || 0) * scaleY);
  let dw = sw, dh = sh;
  const longest = Math.max(sw, sh);
  if (longest > MAX_EDGE_PX) {
    const r = MAX_EDGE_PX / longest;
    dw = Math.round(sw * r);
    dh = Math.round(sh * r);
  }
  const canvas = document.createElement("canvas");
  canvas.width = dw;
  canvas.height = dh;
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingQuality = "medium";
  ctx.drawImage(imgEl, sx, sy, sw, sh, 0, 0, dw, dh);
  const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.7));
  return stampJpegDpi(blob, TARGET_DPI);
}

// Patch JFIF APP0 density so the JPEG reports 250 DPI to printers.
export async function stampJpegDpi(blob, dpi) {
  try {
    const buf = new Uint8Array(await blob.arrayBuffer());
    if (buf[0] === 0xff && buf[1] === 0xd8 && buf[2] === 0xff && buf[3] === 0xe0) {
      const isJfif = buf[6] === 0x4a && buf[7] === 0x46 && buf[8] === 0x49 && buf[9] === 0x46 && buf[10] === 0x00;
      if (isJfif) {
        buf[13] = 1;
        buf[14] = (dpi >> 8) & 0xff; buf[15] = dpi & 0xff;
        buf[16] = (dpi >> 8) & 0xff; buf[17] = dpi & 0xff;
        return new Blob([buf], { type: "image/jpeg" });
      }
    }
  } catch (e) { /* best effort */ }
  return blob;
}

// True if the file should go through the crop editor (images only, not PDF).
export function isCroppableImage(file) {
  return !!file && (file.type || "").startsWith("image/");
}
